import termsApi from '../terms';

/**
 * @param {string} language
 * @param {any} options
 * @returns {Promise<Term[]>}
 */
const fetchTerms = async (language, options) => {
  const termsPromise = termsApi.get(language, options?.query);
  const termsResponse = await termsPromise;
  if (termsResponse.status !== 'OK') {
    throw Error('Got unexpected response');
  }
  const { data } = termsResponse;
  return data.terms;
};

export default fetchTerms;
